import { render, staticRenderFns } from "./DeliveryLinkView.vue?vue&type=template&id=4d255138&scoped=true&"
import script from "./DeliveryLinkView.vue?vue&type=script&lang=js&"
export * from "./DeliveryLinkView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLinkView.vue?vue&type=style&index=0&id=4d255138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/ronaspergel/Projects/otjs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d255138",
  null
  
)

export default component.exports